import { render, staticRenderFns } from "./PresidiPrestazioniEditComponent.vue?vue&type=template&id=3101c3e7"
import script from "./PresidiPrestazioniEditComponent.vue?vue&type=script&lang=js"
export * from "./PresidiPrestazioniEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports